import { ZillowNewsLayout } from '@zillow/zrs-cms';
import React from 'react';

import ContentTemplate from '../../components/ContentTemplate';
import LayoutWrapper from '../../components/LayoutWrapper';
import {
    buildPrimaryPostPage,
    LayoutComponentProps,
} from '../../util/buildPrimaryPostPage';

export const Layout: React.FC<LayoutComponentProps> = (props) => {
    return (
        <LayoutWrapper
            {...props}
            LayoutComponent={ZillowNewsLayout}
            defaultTitle="Zillow Media Room"
            knotchAccountId={
                process.env.NEXT_PUBLIC_KNOTCH_NEWS_LAYOUT_ACCOUNT_ID
            }
        />
    );
};

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryPostPage({
        site: 'NEWS',
        basePath: '/news',
        ContentComponent: ContentTemplate,
        LayoutComponent: Layout,
        contentType: 'B2C',
        knotchAccountId: process.env.NEXT_PUBLIC_KNOTCH_NEWS_LAYOUT_ACCOUNT_ID,
        menuPropName: 'submenu',
        hasStickyNav: true,
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
